import React, { useEffect, useState } from 'react';
import Layout from 'layout/layout';
import { GoArrowUpRight, GoSun } from 'react-icons/go';
import { FiLock, FiUser } from 'react-icons/fi';
import { HiOutlineBuildingOffice2 } from 'react-icons/hi2';
import { retrieveUserData } from 'redux/authSlice';
import { useGetPermissionsByIdQuery } from 'api/userManagementApi';
import { LuFolderClosed } from 'react-icons/lu';
import ModalComponent from 'components/modal-component';
import Error from 'assets/images/error-icon.svg';
import GDPR from 'assets/images/gdpr-data.svg';
import { AiOutlineClose } from 'react-icons/ai';
import ReactCodeInput from 'react-code-input';
import { FloatingLabel, Form } from 'react-bootstrap';

type Props = {}

const Settings: React.FC = (props: Props) => {

  const userRoleId = retrieveUserData()?.roleId || '';

  const { data: permissionsData, isFetching: fetchingPermission, refetch: refetchUserPermission } = useGetPermissionsByIdQuery(userRoleId, { skip: userRoleId ? false : true });
  useEffect(() => {
    if (permissionsData?.data) {
      refetchUserPermission();
    }
  }, []);
  const userPermission = permissionsData?.data && permissionsData?.data?.permissions?.includes("View Settings");

  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showOffCanvas, setShowOffCanvas] = useState(false);
  const [activeTab, setActiveTab] = useState('General');
  const [activeModalTab, setActiveModalTab] = useState('error');

  const handleHideModal = () => {
    setShowModal(false);
  }

  const handleHideOffCanvas = () => {
    setShowOffCanvas(false);
  }

  const [pin, setPin] = useState('');

  const inputcodeprops = {
    inputStyle: {
      margin: '5px',
      paddingLeft: '27px',
      width: '70px',
      borderRadius: '3px',
      fontSize: '30px',
      height: '70px',
      border: 'none',
      backgroundColor: '#F2F2F2',
      borderBottom: '2px solid black'
    }
  }


  return (
    <Layout>
      <section className='my-4'>
        <h5 className='fw-bold'>Settings</h5>
        {/* <div className='text-secondary font-size-normal'><span>Request</span> {'>'}</div> */}
        <div className='row mt-4 mb-2'>
          <div className='col-lg-2'>
            <button className={`${activeTab === "General" ? "btn-primary-outline" : "btn-secondary-outline"} d-flex gap-4 font-size-sm first-font-medium px-3 my-3 w-100`}><FiUser size={20} />General Settings</button>
            <button className={`${activeTab === "Security" ? "btn-primary-outline" : "btn-secondary-outline"} d-flex gap-4 font-size-sm first-font-medium px-3 my-3 w-100`}><FiLock size={20} />Security</button>
            <button className={`${activeTab === "Appearance" ? "btn-primary-outline" : "btn-secondary-outline"} d-flex gap-4 font-size-sm first-font-medium px-3 my-3 w-100`}><GoSun size={20} />Appearance</button>
            <button className={`${activeTab === "Offices" ? "btn-primary-outline" : "btn-secondary-outline"} d-flex gap-4 font-size-sm first-font-medium px-3 my-3 w-100`}><HiOutlineBuildingOffice2 size={20} />Offices</button>
            <button className={`${activeTab === "Sent" ? "btn-primary-outline" : "btn-secondary-outline"} d-flex gap-4 font-size-sm first-font-medium px-3 my-3 w-100`}><GoArrowUpRight size={20} />Sent</button>
            <button className={`${activeTab === "Sent" ? "btn-primary-outline" : "btn-secondary-outline"} d-flex gap-4 font-size-sm first-font-medium px-3 my-4 w-100`}><GoArrowUpRight size={20} />GDPR</button>
          </div>
          <div className='col-lg-10'>
            <div className='row col-4 m-3'>
              <button onClick={() => setShowModal(true)} className='btn bg-white text-start rounded-3 p-3'>
                <span className='text-secondary'><LuFolderClosed size={20} /></span>
                <span className='pt-2 fw-bold font-size-sm d-block'>GDPR Files</span>
                <p className='d-flex justify-content-between p-0 m-0'><span className='font-size-smm text-secondary'>324 files</span> <span className='font-size-smm text-secondary'>32GB</span></p>
              </button>
            </div>
          </div>
        </div>

        <ModalComponent size={activeModalTab == 'fullsidebar' ? 'xl' : undefined} showModal={showModal} hideModal={() => handleHideModal()}>
          {activeModalTab == 'error' && <div className='p-4 d-flex gap-3'>
            <img src={Error} width='100px' />
            <span onClick={() => setActiveModalTab('gdpr')} className='pointer text-dark my-auto font-size-mid'><b>You don't have permission to view
              this folder.</b></span>
            <div className='text-end'>
              <button className='btn p-0'><AiOutlineClose onClick={() => setShowModal(false)} size={20} /></button>
            </div>
          </div>}

          {activeModalTab == 'gdpr' && <div className='pt-4 pb-5 px-4 text-center'>
            <div className='text-end'>
              <button className='btn p-0'><AiOutlineClose onClick={() => setShowModal(false)} size={20} /></button>
            </div>
            <img src={GDPR} width='100px' />
            <p className='text-start pt-3 text-dark my-auto font-size-mid'><b>Enter your PIN to access this folder</b></p>
            <div className='mx-auto text-center mt-4 mb-4'>
              <ReactCodeInput type='number' name='' {...inputcodeprops} value={pin} onChange={setPin} autoFocus={true} inputMode='numeric' fields={4} />
            </div>
            <button type='button' onClick={() => setActiveModalTab('otp')} className='btn-primary rounded-5 w-75'>Continue to SMS verification</button>
          </div>}

          {activeModalTab == 'otp' && <div className='pt-4 pb-5 px-4 text-center'>
            <div className='text-end'>
              <button className='btn p-0'><AiOutlineClose onClick={() => setShowModal(false)} size={20} /></button>
            </div>
            <img src={GDPR} width='100px' />
            <p className='text-start pt-3 text-dark my-auto font-size-mid'><b>Enter OTP sent to +31*****2828 to continue</b></p>
            <div className='mx-auto text-center mt-4 mb-4'>
              <ReactCodeInput type='number' name='' {...inputcodeprops} value={pin} onChange={setPin} autoFocus={true} inputMode='numeric' fields={4} />
            </div>
            <button type='button' onClick={() => setActiveModalTab('pass')} className='btn-primary rounded-5 w-75'>Continue</button>
          </div>}

          {activeModalTab == 'pass' && <div className='pt-4 pb-5 px-4 text-center'>
            <div className='text-end'>
              <button className='btn p-0'><AiOutlineClose onClick={() => setShowModal(false)} size={20} /></button>
            </div>
            <img src={GDPR} width='100px' />
            <p className='text-start pt-3 text-dark my-auto font-size-mid'><b>Enter your login password to continue</b></p>
            <FloatingLabel controlId="floatingInput" label="Email address" className="float-input my-4 mx-2" >
              <Form.Control type='password' placeholder='Enter your login password' className="mt-4 font-size-normal" />
            </FloatingLabel>
            <button type='button' onClick={()=> setActiveModalTab('fullsidebar')} className='btn-primary rounded-5 w-75'>Continue</button>
          </div>}

          {activeModalTab == 'fullsidebar' && <div className='row p-0 m-0 text-center'>
            <div className='col-md-3 bg-light py-4 px-4'>
              <h4>GDPR</h4>
              <button type='button' className='gpdr-button'>Data Categories</button>
              <button type='button' className='gpdr-button'>Files</button>
              <button type='button' className='gpdr-button'>GPDR Settings</button>
            </div>
            <div className='col-md-9'></div>
          </div>}
        </ModalComponent>
      </section>
    </Layout >
  )
}

export default Settings;